<template>
  <application-settings
    :initApp="app"
    :mode="mode"
    :copied="modeArg === 'copy'"
  ></application-settings>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';
.new-application {
  margin-top: 10px;
}
</style>

<script>
// @flow
import ApplicationSettings from './ApplicationSettings'
import { Application, Toast, UnsavedChecker } from 'services'
import Vue from 'vue'

const app = {
  name: '',
  launchwith: '',
  appVersion: '',
  manufacturer: '',
  titlebarcontains: '',
  executablepathcontains: '',
  framecontains: '',
  urlcontains: '',
  processcontains: '',
  md5: '',
  type: 'WEB-CHROME', // Default to WEB to have the first radio ticked.
  icon: ''
}

export default {
  name: 'app-view',
  mixins: [UnsavedChecker.mixin],
  components: { ApplicationSettings },
  props: {
    appId: {
      type: String,
      default: () => ''
    },
    modeArg: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      mode: '',
      app: {}
    }
  },

  methods: {
    readApp(appId) {
      return Application.readApp(appId)
        .then(app => {
          this.app = app
          this.appGroupsToAdd = []
          this.appGroupsToRemove = []
          return app
        })
        .catch(err => {
          Toast.error(
            this.$i18n.t('ERR', {
              action: this.$i18n.t('READ', { thing: this.$i18n.tc('APPLICATION', 1) })
            })
          )
          console.error(err)
        })
    },
    editMode() {
      this.mode = 'edit'
      this.readApp(this.appId)
    },

    createMode() {
      this.mode = 'create'
      this.app = { ...app }
    }
  },

  mounted() {
    if (this.appId) {
      this.editMode()
    } else {
      this.createMode()
    }
  },

  watch: {
    appId: function(newAppId) {
      if (newAppId) {
        this.editMode()
      } else {
        this.createMode()
      }
    }
  }
}
</script>
